export const DECLARE_INTEREST_FORM_TEST_ID = "declare-interest-form";
